window.$ ??= $;
window.jQuery ??= jQuery;

import './css/theme/bpmn.css';
import './css/theme/charts-all.css';
import './css/theme/defaults.css';
import './css/theme/icons_images.css';
import './css/theme/login.css';
import './css/theme/print.min.css';
import './css/theme/widget.css';
import './css/theme/x-platform.css';
import './css/dwh.css';
import "./cryptomodule.js";

// import "@jQuery/jquery.draggable.js"; // плохой модуль
import "@jQuery/jquery.popup.js";
import "@jQuery/jquery.string.1.0.js";

import "@core/platform/base.js";
import "@core/platform/base64.js";
import "@core/platform/cookies.js";
import "@core/platform/waitbox.js";
import "@core/platform/messages.js";
import "@core/platform/client_view.js";
import "@core/platform/view_manager.js";
import "@core/platform/server_messages.js";
import "@core/platform/viewport.js";
import "@core/platform/issue.js";
import "@core/platform/ajax.js";
import "@core/platform/macro.js";
import "@core/platform/statistics.js";
import "@core/platform/startup.js";
import "@core/platform/sign.js";
import "@core/platform/utils.js";
import "@core/template.js";

import "@renderer/renderer.js";
import "@renderer/document.js";
import "@renderer/msgbox.js";
import "@renderer/Views/ActivationView.js";
import "@renderer/Views/LoginView.js";
import "@renderer/Views/NewLoginView.js";
import "@renderer/Views/ChangePasswordBySqlView.js";
import "./js/dwh/Overrides/LoginView.js";
import './trace';
import "./cryptomodule.js";